import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateBenefitCategories } from "./useGetBenefitCategories";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;
  attachmentName: string;
  rowVersion: string;
};
const deleteClientAttachments = async ({
  countryCode,
  clientInternalNumberGOS,
  attachmentName,
  rowVersion,
}: Params) => {
  const response = await api.patch(
    `/client/attachment/delete/${countryCode}/${clientInternalNumberGOS}/${attachmentName}`,
    {
      rowVersion,
    }
  );
  return response.data as Attachment;
};

export function useDeleteClientAttachments() {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateBenefitCategories = useInvalidateBenefitCategories();

  return useMutation(deleteClientAttachments, {
    mutationKey: MUTATION_KEYS.deleteClientAttachment,
    onSuccess: () => {
      invalidateBenefitCategories();
    },
    onError: (error) => {
      handleAddAxiosErrorNotification(error);
    },
  });
}
